import tbDatalist from './tb-datalist.component'

export default angular
  .module('tb.datalist', [])
  .component('tbDatalist', tbDatalist)
  .name
